import { Box, BoxProps, Image, ImageProps } from '@chakra-ui/react';

type ImageGridItemProps = {
  boxProps?: BoxProps;
  imageProps?: ImageProps;
  imageUrl?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  hasHoverEffect?: boolean;
};

export const ImageGridItem = ({
  boxProps,
  imageProps,
  imageUrl,
  onClick,
  children,
  hasHoverEffect = true,
}: ImageGridItemProps) => {
  const content = (
    <Box
      backgroundColor="blackAlpha.50"
      position="relative"
      borderRadius="2px"
      overflow="hidden"
      cursor="pointer"
      h="full"
      w="full"
      {...boxProps}
    >
      {children}
      <Image
        src={imageUrl}
        h="full"
        w="full"
        objectFit="cover"
        objectPosition="center"
        loading="eager"
        fallback={<Box w="100%" h="100%" backgroundColor="blackAlpha.50" />}
        _hover={
          hasHoverEffect ? { WebkitFilter: 'brightness(75%)' } : undefined
        }
        transition="all 1s ease"
        {...imageProps}
      />
    </Box>
  );

  return <Box onClick={onClick}>{content}</Box>;
};
